import { Location } from 'history';

import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { isMarketplacePage } from '@reverbdotcom/commons/src/url_helpers';
import { COUNTRY_CODES, SHIPPING_REGION_CODES } from '../../shared/constants';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';

const CONTROL_GROUP = 0;
const EXPERIMENT_GROUP = 1;
const LTS_V3_GROUP = 3;

export function shouldApplyLikelihoodToSellBoosts(user: Partial<IUser>) {
  return user.countryCode === COUNTRY_CODES.US;
}

export function likelihoodToSellExperimentGroup(user: Partial<IUser>) {
  if (isExperimentEnabled(user, experiments.LIKELIHOOD_TO_SELL_V3_MARKETPLACE) && user.countryCode === COUNTRY_CODES.US) {
    return LTS_V3_GROUP;
  }

  return CONTROL_GROUP;
}

export function ecsBoostExperimentGroup(user: Partial<IUser>, location: Partial<Location>) {
  if (isMarketplacePage(location) && user.shippingRegionCode == SHIPPING_REGION_CODES.US_CON  && !isExperimentEnabled(user, experiments.LIKELIHOOD_TO_SELL_V3_MARKETPLACE))  {
    return EXPERIMENT_GROUP;
  }

  return CONTROL_GROUP;
}
